import type { ConversationState, Message, OnStepSettled } from 'features/onboarding/lib/conversation';
import { ConversationChecklist, SettledStepMessage } from 'features/onboarding/ui/ConversationChecklist';
import { AiBubble, MultiOptionCards, SystemBubble, UserBubble } from 'features/onboarding/ui/OnboardingMessages';
import { OrderPreviewCard } from 'features/onboarding/ui/OrderPreviewCard';

type ChatThreadProps = {
  state: ConversationState;
  onToggleVertical: (id: string) => void;
  onConfirmVerticals: () => void;
  onStepSettled: OnStepSettled;
};

export function ChatThread({ state, onToggleVertical, onConfirmVerticals, onStepSettled }: ChatThreadProps) {
  const renderMessage = (message: Message) => {
    if (message.kind === 'text') {
      if (message.role === 'user') {
        return <UserBubble text={message.text} />;
      }
      if (message.role === 'ai') {
        return <AiBubble text={message.text} />;
      }
      return <SystemBubble>{message.text}</SystemBubble>;
    }
    if (message.kind === 'settled_step') {
      return <SettledStepMessage step={message.step} status={message.status} />;
    }
    if (message.kind === 'order_preview') {
      return <OrderPreviewCard preview={message.preview} idempotencyKey={message.idempotencyKey} />;
    }
    if (message.kind === 'checklist') {
      return <ConversationChecklist onStepSettled={onStepSettled} />;
    }
    // Once past the vertical phase, show the confirmed choices as read-only selected cards.
    const selected = state.phase === 'vertical' ? state.pending : state.verticals;
    return (
      <MultiOptionCards
        prompt={message.prompt}
        options={message.options}
        selected={selected}
        onToggle={onToggleVertical}
        onConfirm={onConfirmVerticals}
        disabled={state.phase !== 'vertical'}
      />
    );
  };

  return (
    <div className="flex flex-col gap-4">
      {state.messages.map((message) => (
        <div key={message.id} className="animate-message-in">
          {renderMessage(message)}
        </div>
      ))}
    </div>
  );
}
